import React, { useEffect, useRef } from 'react';
import './ProfitPulse.css';
import profitPulse from '../../assets/images/profit-pulse.webp';

const ProfitPulse = () => {
  const sectionRef = useRef();

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
          }
        });
      },
      { threshold: 0.1 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  return (
    <div className="profit-pulse" ref={sectionRef} id="products">
      <div className="profit-pulse__container">
        <div className="profit-pulse__image-container">
          <img 
            src={profitPulse} 
            alt="Profit Pulse App" 
            className="profit-pulse__image"
            loading="lazy"
          />
          <div className="profit-pulse__image-glow"></div>
        </div>
        
        <div className="profit-pulse__content">
          <span className="profit-pulse__badge">PROFIT PULSE</span>
          <h2 className="profit-pulse__title">
            Empower Your Business with the
            <span className="profit-pulse__title-highlight"> Ultimate Mobile POS</span> Solution
          </h2>
          <p className="profit-pulse__description">
            Streamline Inventory Management, Invoice Creation,
            and Reporting – Anytime, Anywhere.
          </p>
          
          <div className="profit-pulse__features">
            <div className="profit-pulse__feature">
              <div className="profit-pulse__feature-icon">📋</div>
              <div>
                <h3 className="profit-pulse__feature-title">Inventory Management</h3>
                <p className="profit-pulse__feature-text">Efficiently track, organize, and manage your stock to ensure smooth operations and maximize profitability.</p>
              </div>
            </div>
            
            <div className="profit-pulse__feature">
              <div className="profit-pulse__feature-icon">💵</div>
              <div>
                <h3 className="profit-pulse__feature-title">Invoice Creation</h3>
                <p className="profit-pulse__feature-text">Quickly generate professional invoices, streamline your billing process, and get paid faster with ease.</p>
              </div>
            </div>
            
            <div className="profit-pulse__feature">
              <div className="profit-pulse__feature-icon">📊</div>
              <div>
                <h3 className="profit-pulse__feature-title">Insightful Reports</h3>
                <p className="profit-pulse__feature-text">Unlock valuable business insights with detailed reports that help you make smarter, data-driven decisions.</p>
              </div>
            </div>
            
          </div>
           <button className="bdesign__cta"  onClick={() => window.open('/more_products', '_blank', 'noopener,noreferrer')}>
            More by Skript
            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.25 5L16.25 10L11.25 15" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <path d="M3.75 10H16.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ProfitPulse;